<div hlmField>
  <label hlmFieldLabel for="carto-name" labelRequired>Nom de la nouvelle cartographie</label>
  <input id="carto-name" [(ngModel)]="nomCarto" type="text" hlmInput />
</div>
